// src/App.js
import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { getAccountAnalytics } from "./api/analyticsApi";
import NavBar from "./components/NavBar";
import Dashboard from "./pages/Dashboard";
import Banking from "./pages/Banking";
import FundSuccess from "./pages/FundSuccess";
import Transactions from "./pages/Transactions";
import Analytics from "./pages/Analytics";
import Settings from "./pages/Settings";
import Profile from "./pages/Profile";
import EditProfile from "./pages/EditProfile";
import ChangePassword from "./pages/ChangePassword";
import Support from "./pages/Support";
import Periodic from "./pages/Periodic";

function PrivateRoute({ children }) {
  if (!localStorage.getItem("spectraUser")) {
    window.location.replace(`${process.env.REACT_APP_AUTH_URL}/signin`);
    return null;
  }
  return children;
}

   function App() {

  const [authChecked, setAuthChecked] = useState(false);
  const [accountAnalytics, setAccountAnalytics] = useState({
    equity: 0,
    cash: 0
  });

  const [investAmount, setInvestAmount] = useState("");
  const [lastFundedAmount, setLastFundedAmount] = useState(0);

  const username = localStorage.getItem("spectraUser");


  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const handoffCode = params.get("handoff");

    if (handoffCode) {
      // Exchange the short-lived, single-use handoff code (minted by sgma_extract
      // at login) for the real session data server-side, so the session token
      // never appears in this URL, browser history, or proxy/CDN logs.
      fetch(`${process.env.REACT_APP_SGMA_API_URL}/api/auth/exchange`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ code: handoffCode }),
      })
        .then((res) => {
          if (!res.ok) throw new Error("Handoff exchange failed");
          return res.json();
        })
        .then((data) => {
          localStorage.setItem("spectraUser", data.username);
          if (data.alpacaAccountId) {
            localStorage.setItem("spectraAccountId", data.alpacaAccountId);
          }
          localStorage.setItem("spectraToken", data.token);
          window.history.replaceState({}, document.title, window.location.pathname);
          setAuthChecked(true);
        })
        .catch(() => {
          window.location.replace(`${process.env.REACT_APP_AUTH_URL}/signin`);
        });
      return;
    }

    const storedUser = localStorage.getItem("spectraUser");

    if (!storedUser) {
      window.location.replace(`${process.env.REACT_APP_AUTH_URL}/signin`);
    } else {
      setAuthChecked(true);
    }
  }, []);

  useEffect(() => {
    const handlePageShow = (e) => {
      if (!localStorage.getItem("spectraUser")) {
        window.location.replace(`${process.env.REACT_APP_AUTH_URL}/signin`);
      }
    };
    window.addEventListener("pageshow", handlePageShow);
    return () => window.removeEventListener("pageshow", handlePageShow);
  }, []);


  useEffect(() => {
    if (!authChecked) return;
    async function loadAccount() {
      try {
        const token = localStorage.getItem("spectraToken") || "";
        const res = await fetch(`${process.env.REACT_APP_API_URL}/api/broker/account`, {
          headers: { "Authorization": `Bearer ${token}` }
        });
        const data = await res.json();
        setAccountAnalytics({ equity: data.equity || 0, cash: data.cash || 0 });
      } catch (err) {
        console.error("Failed to load account:", err);
      }
    }

    loadAccount();
  }, [authChecked]);


  const handleFund = (amount) => {
    const numAmount = parseFloat(amount);
    if (!isNaN(numAmount) && numAmount > 0) {
      setLastFundedAmount(numAmount);
      setInvestAmount("");
      return true;
    }
    return false;
  };

  if (authChecked === false) {
    return null;
  }




  return (
    <Router>
      <NavBar username={username} balance={accountAnalytics.equity} />

      <Routes>
        <Route path="/" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
        <Route
          path="/banking"
          element={
            <PrivateRoute>
              <Banking
                investAmount={investAmount}
                setInvestAmount={setInvestAmount}
                onFund={handleFund}
              />
            </PrivateRoute>
          }
        />
        <Route
          path="/fund/success"
          element={<PrivateRoute><FundSuccess lastFundedAmount={lastFundedAmount} /></PrivateRoute>}
        />
        <Route path="/transactions" element={<PrivateRoute><Transactions /></PrivateRoute>} />
        <Route path="/analytics" element={<PrivateRoute><Analytics accountEquity={accountAnalytics.equity} /></PrivateRoute>} />
        <Route path="/settings" element={<PrivateRoute><Settings /></PrivateRoute>} />
        <Route path="/profile" element={<PrivateRoute><Profile /></PrivateRoute>} />
        <Route path="/profile/edit" element={<PrivateRoute><EditProfile /></PrivateRoute>} />
        <Route path="/profile/password" element={<PrivateRoute><ChangePassword /></PrivateRoute>} />
        <Route path="/support" element={<PrivateRoute><Support /></PrivateRoute>} />
        <Route path="/periodic" element={<PrivateRoute><Periodic /></PrivateRoute>} />
      </Routes>
    </Router>
  );
}

export default App;
